import template from './mentorAssign.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($filter, $rootScope, $mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdDialog = $mdDialog;
      ctrl.mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onMentorAssign((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                currentMentee: params.currentMentee,
                accounts: params.accounts
              },
              template,
              controllerAs: '$ctrl',
              controller(currentMentee, accounts) {
                const ctr = this;
                ctr.currentMentee = currentMentee;
                ctr.accounts = accounts;

                ctr.chips = _.map(accounts, (account) => ({
                  id: account.id,
                  name: account.getName(),
                  email: account.user.eMail,
                  image: account.user.avatar
                }));

                ctr.chipsAssigned = _.filter(ctr.chips, (c) => {
                  if (
                    ctr.currentMentee &&
                    $rootScope.CurrentOrganization.mentees &&
                    $rootScope.CurrentOrganization.mentees[currentMentee.id] &&
                    $rootScope.CurrentOrganization.mentees[currentMentee.id].length
                  ) {
                    return _.find(
                      $rootScope.CurrentOrganization.mentees[currentMentee.id],
                      (o) => o === c.id
                    );
                  }
                  return null;
                });
                ctr.chipsFilter = (query) =>
                  query
                    ? _.filter(
                        ctr.chips,
                        (c) => c.name.toLowerCase().indexOf(query.toLowerCase()) > -1
                      )
                    : [];
                ctr.confirm = () => {
                  const filteredAccounts = _.filter(ctr.accounts, (a) =>
                    _.find(ctr.chipsAssigned, (c) => c.id === a.id)
                  );
                  $mdDialog.hide({
                    currentMentee: ctr.currentMentee,
                    accounts: filteredAccounts
                  });
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((res) => {
              ctrl.onFinished({ currentMentee: res.currentMentee, accounts: res.accounts });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
